module.exports = __webpack_public_path__ + "img/2_28.eed8d46c.png";